import { useCallback } from 'react';
import { getCurrentHub } from '@sentry/react';

import { ECookieProcessingServices } from '~/constants/cmp';
import { initSentry } from '~/middlewares/sentry';
import { setYoutubeCookieConsent } from '~/redux/slices/misc';
import { useAppDispatch } from '~/redux/store/useAppDispatch';

export function useOnConsentChange(): (
  consents: Record<ECookieProcessingServices, boolean>,
) => void {
  const dispatch = useAppDispatch();

  const handleYouTubeCookies = useCallback(
    (youTubeConsent: boolean) => {
      dispatch(setYoutubeCookieConsent(youTubeConsent));
    },
    [dispatch],
  );

  const handleSentryCookies = useCallback((sentryConsent: boolean) => {
    // https://github.com/getsentry/sentry-javascript/issues/2039#issuecomment-486667504
    const sentryClient = getCurrentHub().getClient();

    if (sentryClient) {
      // I think this will never take effect as changing consent reloads whole page but better to be sure
      sentryClient.getOptions().enabled = sentryConsent;
    } else if (sentryConsent) {
      initSentry();
    }
  }, []);

  return useCallback(
    (consents) => {
      handleYouTubeCookies(consents[ECookieProcessingServices.YOUTUBE]);
      handleSentryCookies(consents[ECookieProcessingServices.SENTRY]);
    },
    [handleYouTubeCookies, handleSentryCookies],
  );
}
